import { define } from 'wicked-elements'
import bbox from  '@turf/bbox'
import bboxPolygon from  '@turf/bbox-polygon'
import area from  '@turf/area'
import center from  '@turf/center'
import { toApiUri, toAbsolutePath, isMobile, calmFlyTo } from '../../helpers.js'
import { bus, state } from '../../bus.js'
import LayerMarkers from './LayerMarkers'
import LayerPlaces from './LayerPlaces.js'
import PopupsMarkers from './PopupsMarkers.js'
// import PopupsPlaces from './PopupsPlaces'
// import PopupsPermanent from './PopupsPermanent'
// import ContentSync from './ContentSync'

mapboxgl.accessToken = window.MBAT

define('[data-component~="map"]', {
  init () {
    this.state = {
      initialCenter: [-118.41177918139562, 34.02107469934661],
      mapData: {},
      initialZoomDesktop: 10,
      initialZoomMobile: 8.5,
      initialMinZoom: 8.5,
      permanentPopup: false
    }

    this.map = new mapboxgl.Map({
      container: this.element,
      style: window.MBSU,
      center: this.state.initialCenter,
      zoom: this.getInitialZoom(),
      minZoom: this.state.initialMinZoom,
      logoPosition: 'bottom-right',
      attributionControl: false,
      cooperativeGestures: isMobile
    })

    this.handlePage = this.handlePage.bind(this)
    this.handleResize = this.handleResize.bind(this)
  },
  connected () {
    this.map.on('load', () => {
      this.addControls()

      // Plugins
      this.geojsonLayer = new LayerMarkers('site-geojson', this.map)
      this.PopupsMarkers = new PopupsMarkers(['site-geojson-markers', 'site-places-markers'], this.map, this.state)
      // this.PopupsPlaces = new PopupsPlaces(['site-places-markers'], this.map, this.state)
      // this.PopupsPermanent = new PopupsPermanent('site-geojson-circles', this.map, this.state)
      // this.ContentSync = new ContentSync('site-geojson-circles', 'site-geojson', this.map)
      this.LayerPlaces = new LayerPlaces('site-places', this.map, 'site-geojson-clusters')
      this.LayerPlaces.create()

      this.handleInitialPage()
      this.map.touchZoomRotate._tapDragZoom.disable()

      this.resizeObserver = new ResizeObserver(this.handleResize)
      this.resizeObserver.observe(this.element)

      bus.emit('map:ready')
    })

    bus.on('map:page', this.handlePage)
  },
  disconnected () {
    this.resizeObserver.disconnect()
    this.map.remove()
    this.map = null
    bus.removeListener('map:page', this.handlePage)
  },
  getInitialZoom () {
    return window.innerWidth > 1024 ? this.state.initialZoomDesktop : this.state.initialZoomMobile
  },
  getPadding () {
    return window.innerWidth > 1024 ? 100 : 60
  },
  getCenter (center) {
    if (center) {
      return center
    } else {
      return this.state.initialCenter
    }
  },
  addControls () {
    this.map.addControl(new mapboxgl.NavigationControl({ showCompass: false }), 'bottom-left')
    this.map.addControl(new mapboxgl.AttributionControl({ compact: true }), 'bottom-right')
  },
  updateMap (uri) {
    const { geojson, label } = this.state.mapData[uri]
    
    if (geojson) {
      this.geojsonLayer.update(geojson)

      // Fit geojson, unless points are near each other
      // in which case zoom to the center of the points
      const geoBounds = bbox(geojson)
      const geoArea = area(bboxPolygon(geoBounds))
      if (geoArea > 10000) {
        this.map.fitBounds(geoBounds, { 
          padding: this.getPadding() 
        })  
      } else {
        const geoCenter = center(geojson)
        calmFlyTo(geoCenter?.geometry?.coordinates, this.map)
      }
    }

    // If this is a guides route hide/show the POI layer
    if (uri.startsWith('guides')) {
      this.LayerPlaces.hide()
    } else {
      this.LayerPlaces.show()
    }

    // Clear active markers
    bus.emit('map:clearactive')

    // if (label) {
    //   this.PopupsPermanent.open(geojson)
    // } else {
    //   this.PopupsPermanent.close()
    // }
  },
  async handlePage (uri) {
    if (this.state.mapData[uri] === undefined) {
      try {
        const response = await fetch(toAbsolutePath(uri), { method: 'GET' })
        const pagedata = await response.json()
        this.state.mapData[uri] = pagedata
        this.updateMap(uri)
      } catch (e) {}
    } else {
      this.updateMap(uri)
    }
  },
  handleInitialPage () {
    this.handlePage(toApiUri(window.GPLA_APP.state.location))
  },
  handleResize () {
    this.map.resize()
  }
})